import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {FaArrowLeft} from "react-icons/fa";
import {GoChevronDown, GoChevronUp} from "react-icons/go";
import {
    FaCoins, FaBitcoin, FaDollarSign, FaCrown, FaRocket,
    FaTrophy, FaStar, FaTrash,
} from "react-icons/fa6";
import {IoDiamond} from "react-icons/io5";
import ProfileService from "../../services/Profile";
const badgeOptions = [
    {key: "New", label: "New", color: "bg-blue-500"},
    {key: "Hot", label: "Hot", color: "bg-rose-500"},
    {key: "pro", label: "Pro", color: "bg-purple-500"},
    {key: "fast", label: "Fast", color: "bg-emerald-500"},
    {key: "popular", label: "Popular", color: "bg-orange-500"},
    {key: "Free", label: "Free", color: "bg-green-500"},
    {key: "Mix", label: "Mix", color: "bg-indigo-500"},
    {key: "Crypto", label: "Crypto", color: "bg-amber-500"},
];

const iconOptions = [
    {key: "coins", icon: <FaCoins size={20} className="text-yellow-500"/>},
    {key: "bitcoin", icon: <FaBitcoin size={20} className="text-orange-500"/>},
    {key: "dollar", icon: <FaDollarSign size={20} className="text-green-500"/>},
    {key: "crown", icon: <FaCrown size={20} className="text-yellow-600"/>},
    {key: "rocket", icon: <FaRocket size={20} className="text-red-500"/>},
    {key: "trophy", icon: <FaTrophy size={20} className="text-yellow-500"/>},
    {key: "gem", icon: <IoDiamond size={20} className="text-blue-500"/>},
    {key: "star", icon: <FaStar size={20} className="text-yellow-400"/>},
];

const priceOptions = [
    {value: "0", label: "Free"},
    {value: "100000", label: "100,000 USDT"},
    {value: "200000", label: "200,000 USDT"},
    {value: "500000", label: "500,000 USDT"},
    {value: "1000000", label: "1,000,000 USDT"},
    {value: "2000000", label: "2,000,000 USDT"},
    {value: "5000000", label: "5,000,000 USDT"},
];

const initialForm = {name: "", description: "", duration: "", price: ""};

export default function CreatePackage() {
    const navigate = useNavigate();

    const [form, setForm] = useState(initialForm);
    const [badge, setBadge] = useState();
    const [icon, setIcon] = useState();
    const [featureValues, setFeatureValues] = useState([""]);
    const [durations, setDurations] = useState([]);
    const [durationDropdownOpen, setDurationDropdownOpen] = useState(false);
    const [priceDropdownOpen, setPriceDropdownOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getAllDurations = async () => {
            try {
                const response = await ProfileService.getAllDurations();
                setDurations(response?.data?.data || []);
            } catch (error) {
                console.error("Error fetching durations:", error);
                setDurations([]);
            }
        };
        getAllDurations();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".dropdown-container")) {
                setDurationDropdownOpen(false);
                setPriceDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleChange = (e) => {
        const {id, value} = e.target;
        setForm((prev) => ({...prev, [id]: value}));
    };

    const addFeature = () => {
        if (featureValues.length < 5) setFeatureValues((prev) => [...prev, ""]);
    };

    const removeFeature = (index) => {
        setFeatureValues((prev) =>
            prev.length === 1 ? [""] : prev.filter((_, i) => i !== index)
        );
    };

    const handleSubmit = async () => {
        const body = {
            name: form.name,
            price: Number(form.price),
            duration: form.duration,
            description: form.description,
            packageIcon: icon,
            packageBadge: badge,
            packageFeatures: featureValues.filter((f) => f.trim() !== ""),
        };

        try {
            setLoading(true);
            await ProfileService.createPackage(body);
            navigate(-1);
        } catch (error) {
            console.error("Error creating package:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full min-h-screen bg-gray-50 p-4 md:p-8">
            <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="p-5 border-b border-gray-200 flex items-center gap-3">
                    <button onClick={() => navigate(-1)} className="text-secondary">
                        <FaArrowLeft className="text-xl"/>
                    </button>
                    <h1 className="font-bold text-lg">Create New Package</h1>
                </div>

                <div className="p-5 space-y-4">
                    <div>
                        <label className="block font-semibold mb-2">Package Name</label>
                        <input
                            type="text"
                            id="name"
                            value={form.name}
                            onChange={handleChange}
                            placeholder="Enter package name"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-primary focus:outline-none"
                        />
                    </div>

                    <div>
                        <label className="block font-semibold mb-2">Package Icon</label>
                        <div className="grid grid-cols-5 gap-3">
                            {iconOptions.map((item) => (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => setIcon(item.key)}
                                    className={`w-full aspect-square border-2 rounded-xl flex items-center justify-center transition-all duration-200 hover:scale-105 ${
                                        icon === item.key ? "border-primary" : "border-gray-200"
                                    }`}
                                >
                                    {item.icon}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div>
                        <label className="block font-semibold mb-2">Package Badge</label>
                        <div className="grid grid-cols-5 gap-3">
                            {badgeOptions.map((item) => (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => setBadge(item.key)}
                                    className={`w-full aspect-square border-2 rounded-xl flex items-center justify-center transition-all duration-200 hover:scale-105 ${
                                        badge === item.key ? "border-primary" : "border-gray-200"
                                    }`}
                                >
                                    <span className={`text-xs font-bold text-white px-2 py-1 rounded-md ${item.color}`}>
                                        {item.label}
                                    </span>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div>
                        <label className="block font-semibold mb-2">Description</label>
                        <textarea
                            id="description"
                            value={form.description}
                            onChange={handleChange}
                            placeholder="Enter package description"
                            rows="3"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-primary focus:outline-none resize-none"
                        />
                    </div>

                    <div>
                        <div className="flex items-center justify-between mb-3">
                            <label className="block font-semibold">Package Features</label>
                            <button
                                type="button"
                                onClick={addFeature}
                                disabled={featureValues.length >= 5}
                                className="bg-green-100 text-green-700 px-3 py-2 rounded-lg text-sm font-semibold disabled:opacity-50"
                            >
                                + Add Feature
                            </button>
                        </div>

                        <div className="space-y-3">
                            {featureValues.map((feature, index) => (
                                <div key={index} className="flex items-center space-x-3">
                                    <span className="bg-primary/10 text-primary w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                                        {index + 1}
                                    </span>
                                    <input
                                        type="text"
                                        value={feature}
                                        placeholder={`Feature ${index + 1}`}
                                        onChange={(e) =>
                                            setFeatureValues((prev) =>
                                                prev.map((item, i) => (i === index ? e.target.value : item))
                                            )
                                        }
                                        className="flex-1 p-3 border border-gray-300 rounded-lg focus:border-primary focus:outline-none"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => removeFeature(index)}
                                        className="text-red-500 p-2"
                                    >
                                        <FaTrash/>
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    
                    <div className="relative dropdown-container">
                        <label className="block font-semibold mb-2">Duration</label>
                        <div
                            onClick={() => setDurationDropdownOpen((p) => !p)}
                            className="w-full p-3 border border-gray-300 rounded-lg cursor-pointer flex justify-between items-center hover:border-primary transition"
                        >
                            <span className={form.duration ? "text-black" : "text-gray-500"}>
                                {form.duration
                                    ? durations.find((d) => d._id === form.duration)?.days + " days"
                                    : "Select duration"}
                            </span>
                            {durationDropdownOpen ? <GoChevronUp/> : <GoChevronDown/>}
                        </div>

                        {durationDropdownOpen && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                <div
                                    onClick={() => {
                                        setForm((p) => ({...p, duration: ""}));
                                        setDurationDropdownOpen(false);
                                    }}
                                    className="p-3 hover:bg-gray-50 cursor-pointer text-gray-500"
                                >
                                    Select duration
                                </div>
                                {durations.map((d) => (
                                    <div
                                        key={d._id}
                                        onClick={() => {
                                            setForm((p) => ({...p, duration: d._id}));
                                            setDurationDropdownOpen(false);
                                        }}
                                        className="p-3 hover:bg-gray-50 cursor-pointer"
                                    >
                                        {d.days} days
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="relative dropdown-container">
                        <label className="block font-semibold mb-2">Price</label>
                        <div
                            onClick={() => setPriceDropdownOpen((p) => !p)}
                            className="w-full p-3 border border-gray-300 rounded-lg cursor-pointer flex justify-between items-center hover:border-primary transition"
                        >
                            <span className={form.price !== "" ? "text-black" : "text-gray-500"}>
                                {form.price !== ""
                                    ? priceOptions.find((o) => o.value === form.price)?.label
                                    : "Select price"}
                            </span>
                            {priceDropdownOpen ? <GoChevronUp/> : <GoChevronDown/>}
                        </div>

                        {priceDropdownOpen && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                {priceOptions.map((option) => (
                                    <div
                                        key={option.value}
                                        onClick={() => {
                                            setForm((p) => ({...p, price: option.value}));
                                            setPriceDropdownOpen(false);
                                        }}
                                        className="p-3 hover:bg-gray-50 cursor-pointer"
                                    >
                                        {option.label}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="flex space-x-3 pt-4">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="flex-1 p-3 border border-gray-300 rounded-lg text-secondary font-semibold"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleSubmit}
                            disabled={loading}
                            className="flex-1 p-3 bg-primary text-white rounded-lg font-semibold disabled:opacity-60"
                        >
                            {loading ? "Creating..." : "Create Package"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}